<template>
  <div>
    <div class="nav-container">
      <div class="nav-left">
        <router-link to="/" v-slot="{ href, navigate }">
          <a :href="href" @click="navigate">
            <img class="logo" src="@/assets/Logo.svg" alt="Covesto logo" />
          </a>
        </router-link>
      </div>

      <div class="nav-right">
        <ul class="privacy-and-terms">
          <li>
            <a href="mailto:team@covesto.in">Contact Us</a>
          </li>
          <router-link :to="{ name: 'Disclaimer' }" v-slot="{ href }">
            <li>
              <a target="_blank" :href="href">Disclaimer</a>
            </li>
          </router-link>
          <li>
            <a
              href="https://docs.google.com/document/d/1sm4i6dfBknGjvzSn3w6uiCJQbCY-PPJjeIsSeii4EWE/edit?usp=sharing"
              target="_blank"
              >Terms of Use</a
            >
          </li>
          <router-link :to="{ name: 'PrivacyPolicy' }" v-slot="{ href }">
            <li>
              <a target="_blank" :href="href">Privacy Policy</a>
            </li>
          </router-link>
        </ul>
        <v-btn
          color="#2D8CFF"
          class="button"
          :to="{ name: ROUTER_URL.auth.children.login.name }"
          outlined
          >Login</v-btn
        >
      </div>
    </div>
  </div>
</template>
<script>
import ROUTER_URL from "@/constant/urls";
export default {
  data() {
    return {
      ROUTER_URL: ROUTER_URL,
    };
  },
};
</script>

<style scoped>
.nav-container {
  height: 60px;
  display: flex;
  justify-content: space-between;
  padding: 0px 20px;
}
.logo {
  height: 100%;
  cursor: pointer;
  padding-top: 15px !important;
  width: 130px;
}
.button {
  margin-top: 15px !important;
  font-weight: bolder;
  border-radius: 6px;
}

.privacy-and-terms {
  display: none;
}

ul li > a {
  color: rgba(51, 51, 51, 0.87);
  font-weight: 500;
  text-decoration: none;
}

@media all and (min-width: 1300px) {
  .nav-container {
    margin: 10px 50px;
  }

  .logo {
    width: 170px !important;
    height: 100%;
  }
  .nav-right {
    display: inline-flex;
    align-items: center;
  }
  ul li {
    margin-top: 20px;
    color: rgba(51, 51, 51, 0.87);
    font-weight: 500;
  }

  .button {
    margin-top: 20px !important;
    padding: 20px 22px !important;
  }
  .privacy-and-terms {
    display: flex;
    margin: 20px 30px;
    list-style-type: none;
  }
  .privacy-and-terms li {
    padding: 5px 30px;
  }
}
@media all and (min-width: 1620) {
  .nav-container {
    margin: 10px 250px !important;
  }
  .button {
    background: red;
    margin-top: 50px !important;
  }
}
</style>
